export enum RequireAdditionalFinancingOption {
    YES = 'YES',
    NO = 'NO',
    NOT_SURE = 'UNSURE'
}
